import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Api } from '../../contracts/classes/api.class';
import { Media } from '../../contracts/models/media.interface';

@Injectable({ providedIn: 'root' })
export class MediaService extends Api {

    getAll(search='') {
        return this.http.get(`${this.url}/medios${search}`);
    }

    getList() {
        return this.http.get(`${this.url}/medios/data/getList`);
    }

    /** recientes: los medios creados más recientemente primero (para los selectores de los modales) */
    getListSelect(recientes = false) {
        return this.http.get(`${this.url}/medios/select`, { params: recientes ? { orden: 'recientes' } : {} });
    }

    getId(id: number) {
        return this.http.get(`${this.url}/medios/${id}`).pipe(
            map((response: any) => {
                return response.medio;
            })
        );
    }

    edit(id: number, formData: FormData) {
        return this.http.post(`${this.url}/medios/${id}`, formData);
    }

    create(formData: FormData) {
        return this.http.post(`${this.url}/medios`, formData);
    }
    delete(id: number) {
        return this.http.delete(`${this.url}/medios/${id}`);
    }
}
